import Vue from 'vue'
import NuxtLoading from './components/nuxt-loading.vue'

import '../node_modules/buefy/dist/buefy.css'

import '../assets/css/main.scss'

import '../node_modules/@fortawesome/fontawesome-svg-core/styles.css'

import '../node_modules/vue-slick-carousel/dist/vue-slick-carousel.css'

import '../node_modules/vue-slick-carousel/dist/vue-slick-carousel-theme.css'

import '../.tmp/nuxt-bulma-slim.css'


import _741fe452 from '../layouts/acquisition.vue'
import _f3d0c972 from '../layouts/business-campaign.vue'
import _7c809249 from '../layouts/business-test.vue'
import _1352f5b6 from '../layouts/business.vue'
import _6f6c098b from '../layouts/default.vue'
import _e0473622 from '../layouts/go-steady-with-beanfield.vue'
import _6cc66f67 from '../layouts/hybrid-works.vue'
import _e0ea4270 from '../layouts/light-up-with-beanfield.vue'
import _c654d2a2 from '../layouts/residential-campaign.vue'
import _31d6fc9e from '../layouts/residential-test.vue'
import _eeecbdc4 from '../layouts/search.vue'
import _edad3446 from '../layouts/splash.vue'
import _45d40641 from '../layouts/ucaas-voice-solutions.vue'

const layouts = { "_acquisition": _741fe452,"_business-campaign": _f3d0c972,"_business-test": _7c809249,"_business": _1352f5b6,"_default": _6f6c098b,"_go-steady-with-beanfield": _e0473622,"_hybrid-works": _6cc66f67,"_light-up-with-beanfield": _e0ea4270,"_residential-campaign": _c654d2a2,"_residential-test": _31d6fc9e,"_search": _eeecbdc4,"_splash": _edad3446,"_ucaas-voice-solutions": _45d40641 }



export default {
  head: {"titleTemplate":title => {
      return title
        ? `${title} | Beanfield Metroconnect`
        : 'Beanfield Metroconnect';
    },"htmlAttrs":{"lang":"en","prefix":"og: http:\u002F\u002Fogp.me\u002Fns#"},"noscript":[{"innerHTML":"This website requires JavaScript."},{"hid":"gtm-noscript","innerHTML":"\u003Ciframe src=\"\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TBP7R8&l=dataLayer\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"\u003E\u003C\u002Fiframe\u003E","pbody":true}],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"og:title","property":"og:title","content":"Beanfield Metroconnect"},{"hid":"description","name":"description","content":"Every day more and more people are choosing Beanfield. Our fibre, our service, our people. We are dedicated to giving everyone in our ever-expanding network area an experience and service they can count on."},{"hid":"canonical","name":"canonical","href":"https:\u002F\u002Fwww.beanfield.com\u002Fresidential"},{"hid":"og:site_name","property":"og:site_name","content":"Beanfield Metroconnect"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fwww.beanfield.com\u002Fstatic\u002Fimg\u002Fsocial\u002Fbeanfield_tagline_pos[1200x630].jpg"},{"hid":"og:image:width","property":"og:image:width","content":"1200"},{"hid":"og:image:height","property":"og:image:height","content":"360"},{"hid":"twitter:card","name":"twitter:card","content":"summary"},{"hid":"twitter:site","name":"twitter:site","content":"@beanfield"},{"hid":"twitter:image","name":"twitter:image","content":"https:\u002F\u002Fwww.beanfield.com\u002Fstatic\u002Fimg\u002Fsocial\u002Fbeanfield_tagline_pos[200x200].jpg"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Montserrat:300,400,500,600,700"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Poppins:100,200,300,400,500,600,700,700"},{"type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@5.8.55\u002Fcss\u002Fmaterialdesignicons.min.css","rel":"preload","as":"style","onload":"this.rel='stylesheet'"}],"script":[{"hid":"gtm-script","innerHTML":"\n          !(function(s, a, e, v, n, t, z) {\n            if (s.saq) return;\n            n = s.saq = function() {\n              n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);\n            };\n            if (!s._saq) s._saq = n;\n            n.push = n;\n            n.loaded = !0;\n            n.version = '1.0';\n            n.queue = [];\n            t = a.createElement(e);\n            t.async = !0;\n            t.src = v;\n            z = a.getElementsByTagName(e)[0];\n            z.parentNode.insertBefore(t, z);\n          })(window, document, 'script', 'https:\u002F\u002Ftags.srv.stackadapt.com\u002Fevents.js');\n          saq('ts', 'dvS90lybVbvmG0o5OqtxYA');\n        ","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id=GTM-TBP7R8&l=dataLayer","async":true}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"style":[]},
  render(h, props) {
    const loadingEl = h('nuxt-loading', { ref: 'loading' })
    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [ layoutEl ])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      }
    }, [ templateEl ])

    return h('div',{
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,
      transitionEl
    ])
  },
  data: () => ({
    layout: null,
    layoutName: ''
  }),
  beforeCreate () {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created () {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    // add to window so we can listen when ready
    if (typeof window !== 'undefined') {
      window.$nuxt = this
      
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
  },
  
  mounted () {
    this.$loading = this.$refs.loading
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },
  
  methods: {
    
    errorChanged () {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) this.$loading.fail()
        if (this.$loading.finish) this.$loading.finish()
      }
    },
    
    
    setLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    }
    
  },
  components: {
    NuxtLoading
  }
}
